import { render, staticRenderFns } from "./TourSetupModal.vue?vue&type=template&id=62c49b28&scoped=true"
import script from "./TourSetupModal.vue?vue&type=script&lang=ts"
export * from "./TourSetupModal.vue?vue&type=script&lang=ts"
import style0 from "./TourSetupModal.vue?vue&type=style&index=0&id=62c49b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c49b28",
  null
  
)

export default component.exports